import {
  NOTIFICATION_ADD_ENTRY,
  NOTIFICATION_DELETE_ENTRY,
  ORDER_UPDATE_ENTRY,
  NOTIFICATION_CLEAR_ALL,
} from '../constants/ActionTypes';

export const addNotification = (data) => (dispatch) => {
  dispatch({
    type: NOTIFICATION_ADD_ENTRY,
    data,
  });

  return Promise.resolve();
};

export const addOrderUpdateNotification = (data) => (dispatch) => {
  dispatch({
    type: ORDER_UPDATE_ENTRY,
    data,
  });

  return Promise.resolve();
};

export const deleteNotification = (id) => (dispatch) => {
  dispatch({
    type: NOTIFICATION_DELETE_ENTRY,
    data: {
      id,
    },
  });

  return Promise.resolve();
};

export const clearAllNotifications = () => (dispatch) => {
  dispatch({
    type: NOTIFICATION_CLEAR_ALL,
  });

  return Promise.resolve();
};
